import { createStyles } from "@mantine/emotion";

export default createStyles ( {
	seperator: {
		alignSelf  : "center",
		fontWeight : "500"
	}
} );